<script setup>
import { useRouter, useRoute } from 'vue-router'
import { ref, watch, nextTick, computed, shallowRef } from 'vue'
import resolveLayouts from '@/project/layouts/resolveLayouts'

const route = useRoute()
const router = useRouter()

const transitionName = ref('slide-left')
const wrapperTransitionName = ref('')

const stack = shallowRef([]) // { path, Component, layouts, position }
const activePath = ref(route.fullPath)

let currentPosition = window.history.state?.position || 0

function handleNavigation(newPath, name, Component, layouts, newPosition) {
  const stackArr = stack.value
  const prev = stackArr[stackArr.length - 1]

  // Déterminer sens navigation
  if (newPosition < currentPosition) {
    transitionName.value = 'slide-right'
    wrapperTransitionName.value = 'slide-right'
    const idx = stackArr.findLastIndex(p => p.path === newPath)
    if (idx !== -1) stack.value = stackArr.slice(0, idx + 1)
    else
      stackArr.push({
        name: name,
        path: newPath,
        Component,
        layouts,
        position: newPosition,
      })
  } else {
    transitionName.value = 'slide-left'
    wrapperTransitionName.value = 'slide-left'
    if (!prev || prev.path !== newPath) {
      stackArr.push({
        name: name,
        path: newPath,
        Component,
        layouts,
        position: newPosition,
      })
    }
  }

  // Vérifier si wrapper a changé
  if (prev && prev.layouts?.wrapper === layouts?.wrapper) {
    // même wrapper → pas d'animation de wrapper
    wrapperTransitionName.value = null
  }

  currentPosition = newPosition
  activePath.value = newPath
  activePage.value = stack.value[stack.value.length - 1]
}

const activePage = shallowRef(null)
// const activePage = computed(() => stack.value[stack.value.length - 1] || null)

watch(
  () => route.fullPath,
  async newPath => {
    await nextTick()
    const resolved = router.resolve(newPath)
    const matched = resolved.matched[resolved.matched.length - 1]
    const comp = matched?.components?.default
    const layouts = resolveLayouts(route)
    const newPosition = window.history.state?.position || currentPosition + 1
    handleNavigation(newPath, route?.name, comp, layouts, newPosition)
  },
  { immediate: true },
)
</script>

<template>
  <Transition :name="wrapperTransitionName">
    <KeepAlive :max="5">
      <div
        v-if="activePage"
        :key="activePage.layouts?.wrapperName"
        class="sliding-page"
      >
        <component :is="activePage.layouts?.wrapper || 'div'">
          <Transition :name="transitionName">
            <KeepAlive :max="5">
              <div :key="activePage.path" class="sliding-page">
                <component :is="activePage.layouts?.layout || 'div'">
                  <component
                    :is="activePage.Component"
                    :pageName="activePage.name"
                  />
                </component>
              </div>
            </KeepAlive>
          </Transition>
        </component>
      </div>
    </KeepAlive>
  </Transition>
</template>

<style scoped>
.sliding-page {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* Slide wrapper */
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.3s ease;
}
.slide-left-enter-from {
  transform: translateX(100%);
}
.slide-left-leave-to {
  transform: translateX(-100%);
}
.slide-right-enter-from {
  transform: translateX(-100%);
}
.slide-right-leave-to {
  transform: translateX(100%);
}
</style>
